var map = {
	"./decidim/avatar-multiuser.png": 58990,
	"./decidim/brands/facebook.svg": 38920,
	"./decidim/brands/google.svg": 737,
	"./decidim/brands/twitter-x.svg": 34570,
	"./decidim/cc-badge.png": 31760,
	"./decidim/decidim-logo.svg": 73484,
	"./decidim/default-avatar.svg": 96596,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 41040,
	"./decidim/icons.svg": 89263,
	"./decidim/pattern.png": 88992,
	"./decidim/placeholder-card-g.svg": 8629,
	"./decidim/placeholder-card-l.svg": 64894,
	"./decidim/placeholder.jpg": 72141,
	"./decidim/remixicon.symbol.svg": 20897,
	"./decidim/vendor/social-share-button/douban.svg": 16960,
	"./decidim/vendor/social-share-button/email.svg": 46109,
	"./decidim/vendor/social-share-button/facebook.svg": 49219,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 23469,
	"./decidim/vendor/social-share-button/hacker_news.svg": 38813,
	"./decidim/vendor/social-share-button/linkedin.svg": 43029,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 54758,
	"./decidim/vendor/social-share-button/pinterest.svg": 40899,
	"./decidim/vendor/social-share-button/reddit.svg": 16055,
	"./decidim/vendor/social-share-button/telegram.svg": 74874,
	"./decidim/vendor/social-share-button/tumblr.svg": 34649,
	"./decidim/vendor/social-share-button/twitter.svg": 87660,
	"./decidim/vendor/social-share-button/vkontakte.svg": 87538,
	"./decidim/vendor/social-share-button/wechat.svg": 67677,
	"./decidim/vendor/social-share-button/whatsapp.svg": 39597,
	"./decidim/vendor/social-share-button/x.svg": 1213,
	"./decidim/vendor/social-share-button/xing.svg": 72227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31987;